<template>
  <v-form ref="userForm" lazy-validation>

    <v-container fluid class="pt-0 mt-0">
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="10" class="pt-0 pb-0">
          <h1>{{ addOrEditLabel }} Journal Entry</h1>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="7" class="pt-0 pb-0">
          <v-text-field label="What is the title of the journal?" hint="The title should be no more than 50 characters"
            counter="50" v-model="journalTitle" :rules="titleRules">
          </v-text-field>
        </v-col>
        <!-- <v-spacer />
                    </v-row>


                    <v-row>
                      
                      <v-spacer /> -->
        <v-col cols="12" sm="3" class="pt-0 pb-0">
          <!-- Issue Date -->
          <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="issueDate"
            transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="issueDate" label="Issue Publication Date" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" :rules="dateRules">
              </v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer />
      </v-row>



      <v-row>
        <v-spacer />
        <v-col cols="12" sm="10">
          <div class="editor">
            <h2>Journal Cover Note</h2>
            <editor ref="editorElement" api-key="obkrlht14x57mdol58bxqewvhlp88c5lwfj2i9d770gpxomq" initial-value="<br/>"
              v-model="editorContent" id="contentEditor" :init="{
                selector: 'textarea',
                height: 300,
                menubar: false,
                toolbar_mode: 'wrap',
                mobile: {
                  toolbar_mode: 'wrap',
                },
                style_formats: [
                  {
                    title: 'Image Left',
                    selector: 'img',
                    styles: {
                      float: 'left',
                      margin: '0 10px 0 10px',
                    },
                  },
                  {
                    title: 'Image Right',
                    selector: 'img',
                    styles: {
                      float: 'right',
                      margin: '0 10px 0 10px',
                    },
                  },
                ],
                setup: function (editor) {
                  editor.on('init', function (e) {
                    focusEditor(e);
                    editor.execCommand('mceFocus');
                  });
                },
                plugins: ['emoticons', 'lists', 'advlist', 'link', 'anchor', 'image', 'media'],
                toolbar:
                  'undo redo bold italic underline fontsize forecolor | bullist emoticons | copy paste pastetext | link image media',
                contextmenu: false,//'paste | link image inserttable | cell row column deletetable | spellchecker',
                content_css: false,
                browser_spellcheck: true,
                skin: false,
                content_style: contentUiCss.toString() + '\n' + contentCss.toString(),
                automatic_uploads: true,
                smart_paste: true,
                paste_data_images: true,
                paste_preprocess: preProcessPaste,

              }" />
          </div>
        </v-col>
        <v-spacer />
      </v-row>


      <v-row>
        <v-spacer />
        <v-col cols="8" sm="4">
          <v-select :items="journalPdfItems" item-text="fileName" item-value="fullPath" v-model="journalFile"
            label="Journal File" outlined></v-select>
        </v-col>
        <v-col cols="2" sm="1">
          <v-btn class="mt-2 mb-2 primary eps_white" @click="showPdfUploadDialog()">+
            <i aria-hidden="true" class="ma-0 pa-0 v-icon notranslate v-icon--right mdi mdi-file theme--light"
              style="font-size: 16px"></i>
          </v-btn>
        </v-col>
        <v-col cols="8" sm="4">
          <v-select :items="coverImageItems" item-text="fileName" item-value="fullPath" v-model="coverImage"
            label="Cover Image" outlined></v-select>
        </v-col>
        <v-col cols="2" sm="1">
          <v-btn class="mt-2 mb-2 primary eps_white" @click="showCoverImageUploadDialog()">+
            <i aria-hidden="true" class="ma-0 pa-0 v-icon notranslate v-icon--right mdi mdi-image theme--light"
              style="font-size: 16px"></i>
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>



      <v-row v-if="pdfUploadMessage || coverImageUploadMessage">
        <v-spacer />
        <v-col cols="10" sm="5">
          <v-alert dismissible close-text="Close Alert" border="left" width="100%" :type="pdfUploadMessageType"
            :value="showPdfUploadStatusMessage" @input="pdfUploadMessage = null"> {{ pdfUploadMessage }}</v-alert>
        </v-col>
        <v-col cols="10" sm="5">
          <v-alert dismissible close-text="Close Alert" border="left" width="100%" :type="coverImageUploadMessageType"
            :value="showCoverImageUploadStatusMessage" @input="coverImageUploadMessage = null"> {{
              coverImageUploadMessage }}</v-alert>
        </v-col>
        <v-spacer />
      </v-row>



      <v-row v-if="currentImageUrl">
        <v-spacer />
        <v-col cols="12" sm="5">
        </v-col>
        <v-col cols="12" sm="5">
          <v-img :src="currentImageUrl"></v-img>
        </v-col>
        <v-spacer />
      </v-row>


      <v-row v-if="alertMessage">
        <v-spacer />
        <v-col cols="12" sm="10">
          <v-alert dismissible close-text="Close Alert" border="left" width="100%" type="error" v-if="alertMessage">
            {{ alertMessage }}
          </v-alert>
        </v-col>
        <v-spacer />
      </v-row>


      <v-row>
        <v-spacer />
        <v-col cols="12" sm="10" class="text-right">
          <v-btn class="ma-2 error eps_white" outlined to="/siteadmin">Cancel</v-btn>
          <v-btn class="ma-2 green eps_white" outlined @click="addOrEditJournal()">
            Submit
            <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-newspaper-variant-outline theme--light"
              style="font-size: 16px"></i>
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>

      <!-- Upload New PDF Files -->
      <v-dialog v-model="dialogUploadPdf" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 no-word-wrap">Select a PDF file and click 'Upload'</v-card-title>
          <v-card-actions>
            <v-file-input outlined chips show-size accept="application/pdf" label="Click here to select a PDF file"
              @change="pdfFileChanged"></v-file-input>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="hidePdfUploadDialog()">Cancel</v-btn>
            <v-btn color="blue darken-1" text :loading="pdfUploading" @click="processPdfUpload()">Upload</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Upload New Cover Images -->
      <v-dialog v-model="dialogUploadCoverImage" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 no-word-wrap">Select a Cover Image and click 'Upload'</v-card-title>
          <v-card-actions>
            <v-file-input outlined chips show-size accept="image/*" label="Click here to select a cover image"
              @change="coverImageFileChanged"></v-file-input>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="hideCoverImageUploadDialog()">Cancel</v-btn>
            <v-btn color="blue darken-1" text :loading="coverImageUploading" @click="processUpload('coverimage')">Upload
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
</v-form>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import contentUiCss from "!!raw-loader!tinymce/skins/ui/oxide/content.css";
import contentCss from "!!raw-loader!tinymce/skins/content/default/content.css";

import "tinymce/tinymce";
// /* A theme is also required */
import "tinymce/themes/silver/theme.min.js";

// /* Import the skin */
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

import "tinymce/models/dom/model";

import "tinymce/icons/default";

/* Import plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/anchor";
import "tinymce/plugins/media";

import serverFunctions from "@/functions/serverFunctions";
import dateFunctions from "@/functions/dateFunctions";
import userFunctions from "@/functions/userFunctions";


export default {
  components: {
    editor: Editor,
  },
  data: () => ({
    pdfUploadMessage: null,
    pdfUploadMessageType: null,
    coverImageUploadMessage: null,
    coverImageUploadMessageType: null,
    dialogUploadPdf: false,
    updatePdfSucceeded: null,
    updatePdfMessage: null,
    newPdf: null,
    newPdfBase64: null,
    pdfUploading: false,
    dialogUploadCoverImage: false,
    updateCoverImageSucceeded: null,
    updateCoverImageMessage: null,
    newCoverImage: null,
    newCoverImageBase64: null,
    coverImageUploading: false,
    coverImageItems: null,
    journalPdfItems: null,
    coverImage: null,
    journalFile: null,
    journalId: null,
    currentJournalObject: null,
    plugins: [],
    dialog: true,
    journalTitle: "",
    contentUiCss: contentUiCss,
    contentCss: contentCss,
    editorContent: "",
    date: null,
    menu: false,
    issueDate: null,
    alertMessage: null,
    titleRules: [
      v => !!v || 'Title is required',
      v => (v && v.length <= 50) || 'Title must be less than 50 characters',
    ],
    dateRules: [
      v => !!v || 'Issue Date is required'
    ],

  }),
  computed: {
    showPdfUploadStatusMessage() {
      return (this.pdfUploadMessage != null)
    },
    showCoverImageUploadStatusMessage() {
      return (this.coverImageUploadMessage != null)
    },
    addOrEditLabel() {
      return (this.journalId) ? "Edit" : "Add";
    },
    currentImageUrl() {
      return (this.coverImage) ? process.env.VUE_APP_AVATAR_BASE_URL_NEW + this.coverImage : "";
    }
  },
  methods: {
    preProcessPaste(plugin, args) {

      this.alertMessage = null;

      let url = args.content;

      if (url.indexOf("blob:") <= 0) {
        return; //not a blob, continue
      }

      args.stopImmediatePropagation();
      args.stopPropagation();
      args.preventDefault();

      let start = url.indexOf("src=") + 5;
      let end = url.lastIndexOf("\"");
      url = url.substring(start, end);

      let blob = fetch(url).then(r => r.blob());
      let maxAlowableSize = 250000; //250kb, qtr of a meg
      var pastedImageSize = -1;

      Promise.all([blob]).then((value) => {
        pastedImageSize = value[0].size

        if (pastedImageSize <= maxAlowableSize) {
          if (args.content != null && args.content.length > 0) {
            if (this.editorContent == null) {
              this.editorContent = ""
            }
            this.editorContent += args.content
          }
        } else {
          this.alertMessage = "The image you're pasting into the window is too large to paste. Consider uploading it to a file sharing site and using the 'insert image' icon in the toolbar"
        }

      });
    },
    showPdfUploadDialog() {
      this.dialogUploadPdf = true;
    },
    hidePdfUploadDialog() {
      this.dialogUploadPdf = false;
    },
    showCoverImageUploadDialog() {
      this.dialogUploadCoverImage = true;
    },
    hideCoverImageUploadDialog() {
      this.dialogUploadCoverImage = false;
    },
    pdfFileChanged(file) {
      this.updatePdfSucceeded = null;
      this.updatePdfMessage = null;
      this.newPdf = null;
      this.newPdfBase64 = null;
      if (file) {
        this.newPdf = file;
        this.readBase64Image(file, 'pdf');
      }
    },
    coverImageFileChanged(file) {
      this.updateCoverImageSucceeded = null;
      this.updateCoverImageMessage = null;
      this.newCoverImage = null;
      this.newCoverImageBase64 = null;
      if (file) {
        this.newCoverImage = file;
        this.readBase64Image(file, 'coverimage');
      }
    },
    async readBase64Image(file, type) {
      let reader = new FileReader();
      if (type == 'pdf') {
        reader.onload = (e) => {
          this.newPdfBase64 = e.target.result.slice(e.target.result.indexOf(",") + 1);
        };
      } else {
        reader.onload = (e) => {
          this.newCoverImageBase64 = e.target.result.slice(e.target.result.indexOf(",") + 1);
        };
      }

      await reader.readAsDataURL(file);
    },
    async processPdfUpload() {

      this.pdfUploading = true;

      let uploadUrlRequest = serverFunctions.getUploadUrlRequest(
        userFunctions.getLoggedInUser(),
        this.newPdf.name)

      let urlResponse = null;
      
      try {
        urlResponse = await serverFunctions.getRawPostResponse(
        "/getS3UploadPdfUrl",
        uploadUrlRequest
      );
      }
      catch(ex){
        console.log(ex)
      }

      let uploadUrl = urlResponse.uploadUrl;
      let pathAndFilename = urlResponse.pathAndFilename;

      if (!uploadUrl || uploadUrl.length == 0) {
        this.pdfUploading = false;
        this.pdfUploadMessage = "Upload PDF failed, please try again or contact Paul if the problem persists.";
        this.pdfUploadMessageType = "error";
        this.dialogUploadPdf = false;
        return;
      }

      const formData = new FormData();
      formData.append("image", this.newPdf)

      const result = await fetch(
        uploadUrl,
        {
          method: "PUT",
          body: formData,
          headers: {
            'Content-Type': 'application/pdf',
            'Content-Disposition': 'inline',
          },
        }
      );

      if(result.status == 200) {
        this.pdfUploadMessage = "Upload PDF succeeded";
        this.pdfUploadMessageType = "success";
        await this.getJournalPDFFiles();
        this.journalFile = pathAndFilename;
      } else {
        this.pdfUploadMessage = "Upload PDF failed, please try again or contact Paul if the problem persists";
        this.pdfUploadMessageType = "error";
      }
      this.pdfUploading = false;
      this.dialogUploadPdf = false;

    },
    async processUpload(type) {

      let uploadRequest = (type == 'pdf') ? serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newPdf.name,
        this.newPdf.type,
        this.newPdfBase64
      ) : serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newCoverImage.name,
        this.newCoverImage.type,
        this.newCoverImageBase64
      );

      if (type == 'pdf') {
        this.pdfUploading = true;
      }
      else {
        this.coverImageUploading = true;
      }

      let uploadResponse = null;
      let path = (type == 'pdf') ? "/uploadJournalPdf" : "/uploadJournalCoverImage";

      try {
        uploadResponse = await serverFunctions.getPostResponse(
          path,
          uploadRequest
        );
      } catch (exception) {
        console.log(exception);
      }

      if (
        !uploadResponse ||
        uploadResponse.length == 0 ||
        !uploadResponse[0].success
      ) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage =
          "Image upload failed. Please check your connection and try again";

        if (type == 'pdf') {
          this.pdfUploading = false;
          this.pdfUploadMessage = "Upload PDF failed, please try again or contact Paul if the problem persists";
          this.pdfUploadMessageType = "error";
          this.dialogUploadPdf = false;

        } else {
          this.coverImageUploading = false;
          this.coverImageUploadMessage = "Upload Cover Image failed, please try again or contact Paul if the problem persists";
          this.coverImageUploadMessageType = "error";
          this.dialogUploadCoverImage = false;
        }

        return;
      }

      if (type == 'pdf') {
        this.pdfUploading = false;
        await this.getJournalPDFFiles();
        this.journalFile = uploadResponse[0].imagePathAndFilename
        this.pdfUploadMessage = "Upload PDF successuful";
        this.pdfUploadMessageType = "success";

        this.dialogUploadPdf = false;
      }
      else {
        this.coverImageUploading = false;
        await this.getJournalCoverImages();
        this.coverImage = uploadResponse[0].imagePathAndFilename
        this.coverImageUploadMessage = "Upload Cover Image successful";
        this.coverImageUploadMessageType = "success";
        this.dialogUploadCoverImage = false;
      }


    },
    async getJournalCoverImages() {
      this.coverImageItems = await serverFunctions.getResponse("/getJournalCoverImages");
    },
    async getJournalPDFFiles() {
      this.journalPdfItems = await serverFunctions.getResponse("/getJournalPDFFiles");
    },
    addOrEditJournal() {

      if (this.journalTitle == null || this.journalTitle.length < 1) {
        this.alertMessage = "Please add a title"
        return;
      }

      if (this.issueDate == null || this.issueDate.length < 8) {
        this.alertMessage = "Please select an issue publish date"
        return;
      }

      if (this.coverImage == null) {
        this.alertMessage = "Please select a cover image";
        return;
      }

      if (this.journalFile == null) {
        this.alertMessage = "Please select a journal file";
        return;
      }

      this.alertMessage = null;

      if (!this.journalId || !this.currentJournalObject) {
        let title = this.journalTitle;
        let content = this.editorContent;
        let issueDate = dateFunctions.serialisePalmDate(this.issueDate);
        let journalFile = this.journalFile;
        let coverImage = this.coverImage;

        let journalRequest = serverFunctions.getNewJournalRequest(userFunctions.getLoggedInUser(), title, content, issueDate, journalFile, coverImage);

        serverFunctions.getPostResponse("/addNewsLetter", journalRequest);

        this.$router.push("/siteadmin");
      }
      else {

        this.currentJournalObject[0].title = this.journalTitle
        this.currentJournalObject[0].issueDate = dateFunctions.serialisePalmDate(this.issueDate);
        this.currentJournalObject[0].contents = this.editorContent
        this.currentJournalObject[0].coverImage = this.coverImage
        this.currentJournalObject[0].pdfFile = this.journalFile

        let journalRequest = serverFunctions.getUpdateJournalRequest(userFunctions.getLoggedInUser(), this.currentJournalObject[0]);

        serverFunctions.getPostResponse("/updateNewsLetter", journalRequest);

        this.$router.push("/siteadmin");

      }
    },
    async loadJournalObject() {
      if (!this.journalId) {
        return;
      }

      let getJournalRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser(), this.journalId);

      this.currentJournalObject = await serverFunctions.getPostResponse("/getNewsLetter", getJournalRequest);

      this.journalTitle = this.currentJournalObject[0].title
      this.editorContent = this.currentJournalObject[0].contents
      this.issueDate = dateFunctions.deserialisePalmDate(this.currentJournalObject[0].issueDate);
      this.coverImage = this.currentJournalObject[0].coverImage
      this.journalFile = this.currentJournalObject[0].pdfFile

    },
    focusEditor(e) {
      e.target.selection.select(e.target.getBody(), true);
      e.target.selection.collapse(false);
      e.target.selection.scrollIntoView();
      e.target.focus();
    },
  },
  beforeMount() {
    this.journalId = this.$route.params.journalId;
    this.getJournalCoverImages();
    this.getJournalPDFFiles();
  },
  mounted() {
    if (this.journalId) {
      this.loadJournalObject()
    }
    this.$refs.userForm.validate();
  },
};
</script>

<style>
.ck .ck-editor__editable_inline {
  min-height: 400px;
  height: 400px;
}
</style>